"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var smart_1 = require("./smart");
var vegas_1 = require("./vegas");
exports.armies = (_a = {},
    _a[types_1.Armies.Smart] = smart_1.smartArmy,
    _a[types_1.Armies.Vegas] = vegas_1.vegasArmy,
    _a);
